// extracted by mini-css-extract-plugin
export default {"root":"Draggable_root__q5ou2","dragging":"Draggable_dragging__j1gZn"};